export default "__VITE_ASSET__C8jwnSbh__"